import { render, staticRenderFns } from "./ScreenIdle.vue?vue&type=template&id=596c332b"
import script from "./ScreenIdle.vue?vue&type=script&lang=js"
export * from "./ScreenIdle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports